const az = {
  nav: {
    home: "Ana Səhifə",
    register: "Qeydiyyat",
    login: "Daxil Ol",
    support: "Dəstək",
    logout: "Çıxış",
    pricing: "Tariflər",
  },
  home: {
    hero_tag: "Azərbaycan Vətəndaşları üçün",
    hero_title: "Təhlükəsiz Email Xidməti",
    hero_subtitle: "FİN əsaslı təsdiqlənmiş hesablar. Dövlət standartlarına uyğun məlumat təhlükəsizliyi. mail.net.az",
    hero_cta: "İndi Qeydiyyatdan Keç",
    hero_login: "Daxil Ol",
    features_title: "Niyə Mail.net.az?",
    features_subtitle: "Azərbaycanlılar üçün Azərbaycanlılar tərəfindən hazırlanmış",
    feature1_title: "FİN Əsaslı Təsdiq",
    feature1_desc: "Yalnız Azərbaycan vətəndaşları üçün. Şəxsiyyət vəsiqəsi FİN kodu ilə tam təsdiqlənmiş hesablar.",
    feature2_title: "99.9% Uptime",
    feature2_desc: "Dövlət standartlarına uyğun server infrastrukturu. 24/7 monitorinq və davamlı xidmət.",
    feature3_title: "End-to-End Şifrələmə",
    feature3_desc: "Bütün məktublarınız AES-256 şifrələmə ilə qorunur. Tam məxfilik zəmanəti.",
    feature4_title: "Azərbaycanca İnterfeys",
    feature4_desc: "AZ, RU, EN dilləri dəstəyi. Rahat və tanış istifadəçi interfeysi.",
    stats_label: "Rəqəmlərlə Mail.net.az",
    stats_desc: "Azərbaycanın ən etibarlı email hosting platforması. Minlərlə vətəndaş artıq mail.net.az-a etibar edir.",
    stat1_num: "25,000+",
    stat1_label: "Aktiv İstifadəçi",
    stat2_num: "99.9%",
    stat2_label: "Server Əlçatanlığı",
    stat3_num: "24/7",
    stat3_label: "Texniki Dəstək",
    stat4_num: "100%",
    stat4_label: "AZ Vətəndaşları",
    reviews_title: "Vətəndaşlarımız Nə Deyir",
    reviews_label: "İstifadəçi Rəyləri",
    cta_title: "Təhlükəsiz Email Hesabınızı İndi Yaradın",
    cta_subtitle: "5 dəqiqədə qeydiyyat. FİN təsdiqi ilə tam funksional hesab.",
    cta_btn: "Qeydiyyata Başla",
  },
  register: {
    title: "Yeni Hesab Yaradın",
    subtitle: "Azərbaycan Vətəndaşları üçün Eksklüziv",
    firstname: "Ad",
    lastname: "Soyad",
    email: "Email ünvanı",
    email_placeholder: "ad.soyad@mail.net.az",
    fin: "FİN Nömrəsi",
    fin_placeholder: "7 rəqəmli FİN kodu",
    id_serial: "Vəsiqə Seriyası",
    id_serial_placeholder: "AZE",
    id_number: "Vəsiqə Nömrəsi",
    id_number_placeholder: "00000000",
    phone: "Telefon nömrəsi",
    phone_placeholder: "+994 50 000 00 00",
    password: "Şifrə",
    password_placeholder: "Ən az 8 simvol",
    confirm_password: "Şifrənin Təkrarı",
    confirm_password_placeholder: "Şifrəni təkrar daxil edin",
    terms: "Xidmət şərtlərini qəbul edirəm",
    terms_link: "Şərtlər",
    btn: "Qeydiyyatı Tamamla",
    already: "Artıq hesabınız var?",
    login_link: "Daxil Olun",
    feature1: "FİN əsaslı tam təsdiq",
    feature2: "Dövlət standartları",
    feature3: "Tam məxfilik zəmanəti",
    fin_info: "FİN nömrənizi şəxsiyyət vəsiqənizdən tapa bilərsiniz. mail.net.az üçün FİN məcburidir.",
    success: "Qeydiyyat müraciətiniz qəbul edildi!",
    success_msg: "Ən qısa zamanda email ünvanınıza bildiriş göndəriləcək.",
    error_fin: "FİN nömrəsi 7 rəqəmdən ibarət olmalıdır",
    error_password: "Şifrələr uyğun gəlmir",
    error_terms: "Şərtləri qəbul etməlisiniz",
  },
  login: {
    title: "Hesabınıza Daxil Olun",
    subtitle: "Mail.net.az portalına xoş gəldiniz",
    email: "Email ünvanı",
    email_placeholder: "ad.soyad@mail.net.az",
    password: "Şifrə",
    password_placeholder: "Şifrənizi daxil edin",
    remember: "Məni xatırla",
    forgot: "Şifrəni unutmusunuz?",
    btn: "Daxil Ol",
    fin_btn: "FİN ilə Daxil Ol",
    or: "və ya",
    no_account: "Hesabınız yoxdur?",
    register_link: "Qeydiyyatdan keçin",
    secure: "SSL şifrələnmiş təhlükəsiz bağlantı",
    fin_modal_title: "FİN ilə Daxil Ol",
    fin_modal_desc: "FİN nömrənizi və şifrənizi daxil edin",
    fin_modal_fin: "FİN Nömrəsi",
    fin_modal_pass: "Şifrə",
    fin_modal_btn: "Təsdiq Et",
    fin_modal_close: "Bağla",
  },
  support: {
    hero_title: "Sizə Necə Kömək Edə Bilərik?",
    hero_placeholder: "Sualınızı yazın...",
    contact1_title: "Telefon Dəstəyi",
    contact1_num: "+994 12 000 00 00",
    contact1_hours: "Həftəiçi 09:00 - 18:00",
    contact2_title: "Email Dəstəyi",
    contact2_addr: "support@mail.net.az",
    contact2_time: "24 saat ərzində cavab",
    contact3_title: "Canlı Chat",
    contact3_btn: "İndi Başla",
    contact3_status: "Hazırda aktiv",
    faq_title: "Tez-tez Verilən Suallar",
    faq_subtitle: "Ən çox soruşulan suallara cavablar",
    form_title: "Bizə Yazın",
    form_name: "Ad Soyad",
    form_email: "Email",
    form_subject: "Mövzu",
    form_message: "Mesajınız",
    form_btn: "Göndər",
    form_success: "Mesajınız göndərildi! Ən qısa zamanda cavab veriləcək.",
    office_title: "Ofis Məlumatları",
    office_addr: "Bakı şəh., Nərimanov r., Əhməd Cavad küç. 20",
    office_hours: "Həftəiçi: 09:00 - 18:00",
    office_weekend: "Şənbə: 10:00 - 15:00",
  },
  pricing: {
    hero_tag: "Şəffaf Qiymətlər",
    hero_title: "Sizə Uyğun Tarifi Seçin",
    hero_subtitle: "Bütün planlarda FİN doğrulaması və dövlət standartlarına uyğun təhlükəsizlik daxildir.",
    monthly: "Aylıq",
    annual: "İllik",
    annual_badge: "2 ay pulsuz",
    popular: "Ən Populyar",
    plan1_name: "Şəxsi",
    plan1_desc: "Fərdi istifadəçilər üçün ideal başlanğıc paketi",
    plan1_price_monthly: "Pulsuz",
    plan1_price_annual: "Pulsuz",
    plan2_name: "Biznes",
    plan2_desc: "Kiçik və orta müəssisələr üçün güclü həll",
    plan2_price_monthly: "₼15",
    plan2_price_annual: "₼12",
    plan3_name: "Korporativ",
    plan3_desc: "Böyük təşkilatlar üçün tam funksional paket",
    plan3_price_monthly: "₼49",
    plan3_price_annual: "₼39",
    per_month: "/ay",
    get_started: "Başla",
    contact_sales: "Satış ilə əlaqə",
    current_plan: "Cari Plan",
    feature_table_title: "Planlar Üzrə Müqayisə",
    feature_table_subtitle: "Hər planın daxil etdiyi xüsusiyyətləri müqayisə edin",
    cta_title: "Hələ Seçim Etmədiniz?",
    cta_subtitle: "Biznes tələbatlarınızı bizimlə müzakirə edin — sizə ən uyğun planı birlikdə tapaq.",
    cta_btn: "Ekspertlə Danış",
    month_short: "ay",
  },
  footer: {
    desc: "Mail.net.az — Azərbaycan vətəndaşları üçün təhlükəsiz, FİN əsaslı email hosting xidməti.",
    services: "XİDMƏTLƏR",
    email_hosting: "Email Hosting",
    domain: "Domen Qeydiyyatı",
    ssl: "SSL Sertifikatı",
    help: "DƏSTƏK",
    faq: "FAQ",
    contact: "Əlaqə",
    docs: "Sənədlər",
    legal: "HÜQUQİ",
    terms: "İstifadə Şərtləri",
    privacy: "Məxfilik Siyasəti",
    gdpr: "GDPR",
    copyright: "© 2025 Mail.net.az. Bütün hüquqlar qorunur.",
  },
};

export default az;
